"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("./utils/index");
var _mobileViewTypes = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes"));
var _fullscreenCartButton = _interopRequireDefault(require("./proGallery/fullscreenCartButton.js"));
var _fullscreenCartIcon = _interopRequireDefault(require("./proGallery/fullscreenCartIcon.js"));
var _fullscreenStoreBottomMobileBar = _interopRequireDefault(require("./proGallery/fullscreenStoreBottomMobileBar.js"));
var _fullscreenCheckoutLink = _interopRequireDefault(require("./proGallery/fullscreenCheckoutLink.js"));
var _artstorePageManager = _interopRequireDefault(require("./applications/gallery/artstorePageManager.js"));
var _consts = require("./applications/consts");
var _fullscreenShop = _interopRequireDefault(require("./applications/gallery/fullscreenShop"));
var _photographyClientLib = require("@wix/photography-client-lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var withArtStore = function withArtStore(_ref) {
  var id = _ref.id,
    _ref$isOOI = _ref.isOOI,
    isOOI = _ref$isOOI === void 0 ? false : _ref$isOOI,
    _ref$viewMode = _ref.viewMode,
    viewMode = _ref$viewMode === void 0 ? 'editor' : _ref$viewMode,
    galleryInfo = _ref.galleryInfo,
    wixSdk = _ref.wixSdk,
    storeApi = _ref.storeApi,
    baseUrl = _ref.baseUrl,
    customShopWrapper = _ref.customShopWrapper,
    customIconWrapper = _ref.customIconWrapper,
    _ref$closeFullscreen = _ref.closeFullscreen,
    closeFullscreen = _ref$closeFullscreen === void 0 ? function () {} : _ref$closeFullscreen,
    updateUrl = _ref.updateUrl;
  return function (ComposedComponent) {
    var ArtStoreHOC = /*#__PURE__*/function (_Component) {
      function ArtStoreHOC(props) {
        var _this$props$additiona;
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
          showMobileShopFrame: false,
          providerView: null
        };
        _this.galleryInfo = galleryInfo;
        _this.connectedProviders = galleryInfo.connectedProviders;
        _this.isMobile = _index.utils.isMobile();
        _this.deviceType = _this.isMobile ? 'mobile' : 'desktop';
        _this.init(_this.connectedProviders);
        _this.toggleMobileShopFrame = _this.toggleMobileShopFrame.bind(_this);
        _this.goToCheckout = _this.goToCheckout.bind(_this);
        _this.firstTime = true;
        _this.isFreeArtStore = (_this$props$additiona = _this.props.additionalProviderParams) == null ? void 0 : _this$props$additiona.freeArtStore;
        return _this;
      }
      _inheritsLoose(ArtStoreHOC, _Component);
      var _proto = ArtStoreHOC.prototype;
      _proto.init = function init(connectedProviders) {
        if (connectedProviders) {
          if (!isOOI) {
            storeApi.initCart(this.connectedProviders);
          } else {
            this.pageManager = new _artstorePageManager["default"]({
              id: id,
              isMobile: this.isMobile,
              viewMode: this.props.viewMode.toLowerCase(),
              connectedProviders: this.connectedProviders,
              locale: this.props.locale,
              storeApi: storeApi,
              deviceType: this.deviceType,
              baseUrl: baseUrl,
              closeFullscreen: closeFullscreen,
              updateUrl: updateUrl
            });
          }
          storeApi.refreshCartItems(connectedProviders);
        }
      };
      _proto.calcShopSize = function calcShopSize(_ref2) {
        var allowTitleExpand = _ref2.allowTitleExpand,
          allowLinkExpand = _ref2.allowLinkExpand,
          allowDescriptionExpand = _ref2.allowDescriptionExpand,
          title = _ref2.title,
          description = _ref2.description,
          link = _ref2.link;
        var size = _photographyClientLib.window.innerHeight - 350;
        size = allowTitleExpand && title ? size - 100 : size;
        size = allowDescriptionExpand && description ? size - 50 : size;
        size = allowLinkExpand && link ? size - 50 : size;
        return size;
      };
      _proto.getConsentPolicyQuery = function getConsentPolicyQuery() {
        if (isOOI) {
          var consentPolicy = this.props.consentPolicy;
          return this.pageManager.getConsentPolicyQuery(consentPolicy);
        } else {
          return undefined;
        }
      };
      _proto.isImage = function isImage(item) {
        var type = item.type,
          fileType = item.fileType;
        return (type === 'image' || type === 'picture') && fileType !== 'gif';
      };
      _proto.updateUrlEditorProductIdIfNeeded = function updateUrlEditorProductIdIfNeeded(editorProductId) {
        var curEditorProductId = _index.utils.getQueryParamByName('product');
        if (editorProductId && editorProductId !== curEditorProductId) {
          var neededUrl = _photographyClientLib.window.location.href + '&product=' + editorProductId;
          updateUrl(neededUrl);
        }
      };
      _proto.getFirstTimeDataForShop = function getFirstTimeDataForShop(curItem, galleryId) {
        var productId = _index.utils.getQueryParamByName('product');
        if (!productId) return null;
        var shopData = curItem.getDataForShop();
        delete shopData.imagePurchasedUrl;
        delete shopData.itemId;
        delete shopData.itemType;
        delete shopData.orderIndex;
        return _objectSpread(_objectSpread({}, shopData), {}, {
          galleryId: galleryId,
          name: 'editor',
          referer: 'shop',
          pricelistId: undefined,
          urlParams: _objectSpread(_objectSpread({}, shopData), {}, {
            galleryId: galleryId,
            referer: 'shop'
          }),
          urlPath: "/" + productId
        });
      };
      _proto.fullScreenShopElement = function fullScreenShopElement(props) {
        var _this2 = this;
        var curItem = props.current.item;
        if (!this.isImage(curItem)) {
          return false;
        }
        var _this$galleryInfo = this.galleryInfo,
          styleId = _this$galleryInfo.styleId,
          pageId = _this$galleryInfo.pageId,
          galleryId = _this$galleryInfo.galleryId;
        var isMobile = this.isMobile;
        var consentPolicyQuery = this.getConsentPolicyQuery();
        var shopContainerStyle = {};
        var storeHeight = this.calcShopSize(_objectSpread(_objectSpread({}, props.styleParams), curItem));
        !isMobile && (shopContainerStyle.maxHeight = storeHeight);
        isMobile && !props.isAdditionalMobileSidebarOpened && (shopContainerStyle.visibility = 'hidden');
        var openShopEditor = function openShopEditor(editorData) {
          _this2.updateUrlEditorProductIdIfNeeded(editorData.urlPath.replace('/', ''));
          _this2.pageManager.shopEditorData = editorData;
          _this2.props.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.EDITOR, true);
        };
        if (this.firstTime && this.props.openEditorOnLoad) {
          var editorData = this.getFirstTimeDataForShop(curItem, galleryId);
          if (editorData) {
            this.props.openEditorOnLoad = false;
            this.firstTime = false;
            openShopEditor(editorData);
          }
        }
        var shopContainerClassName = 'fullscreen-shop-container ' + (isMobile ? 'mobile' : '');
        var shopButtonsClassName = 'fullscreen-shop-buttons ' + (isMobile ? 'mobile' : '');
        var visibility = this.props.hideShopFrame ? 'hidden' : 'visible';
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            height: '100%',
            visibility: visibility
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: shopContainerClassName,
          style: shopContainerStyle
        }, /*#__PURE__*/_react["default"].createElement(_fullscreenShop["default"], {
          wixSdk: wixSdk,
          storeApi: storeApi,
          storeHeight: storeHeight,
          cartItemsData: this.props.cartItemsData,
          ref: function ref(element) {
            return _this2.shopElement = element;
          },
          item: curItem,
          styleParams: props.styleParams,
          isOOI: isOOI,
          styleId: styleId,
          additionalProviderParams: this.props.additionalProviderParams,
          toggleShopEditorPage: openShopEditor,
          toggleMobileShopFrame: this.toggleMobileShopFrame,
          pageId: pageId,
          consentPolicy: consentPolicyQuery,
          isMobile: isMobile,
          locale: props.locale,
          deviceType: this.deviceType,
          viewMode: viewMode,
          onSetMobileData: function onSetMobileData(type, data) {
            return _this2.setState({
              providerView: {
                type: type,
                data: data
              }
            });
          },
          connectedProviders: this.connectedProviders,
          galleryId: galleryId
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: shopButtonsClassName
        }, this.getShopButtons()));
      };
      _proto.fullscreenCartIcon = function fullscreenCartIcon() {
        var _this3 = this;
        return /*#__PURE__*/_react["default"].createElement(_fullscreenCartIcon["default"], {
          showCart: function showCart() {
            return _this3.showCart();
          },
          cartItemsCount: this.getCartItemsCount()
        });
      };
      _proto.showCart = function showCart() {
        isOOI ? this.props.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true) : storeApi.showCart();
      };
      _proto.getCartItemsCount = function getCartItemsCount() {
        var _this$props = this.props,
          cartItemsData = _this$props.cartItemsData,
          cartItemsCount = _this$props.cartItemsCount;
        var count = cartItemsData && cartItemsData.cartItemsCount;
        return count || cartItemsCount || 0;
      };
      _proto.getShopButtons = function getShopButtons() {
        var _this4 = this;
        var _this$state = this.state,
          providerView = _this$state.providerView,
          showMobileShopFrame = _this$state.showMobileShopFrame;
        var showAddToCart = providerView && providerView.type === _mobileViewTypes["default"].singleProduct;
        var isMobile = this.isMobile;
        var showCheckoutLink = !isMobile || !showMobileShopFrame;
        var addToCartRequest = function addToCartRequest() {
          _this4.closeMobileShopFrameIfOpen();
          _this4.shopElement.addToCartRequest();
        };
        return /*#__PURE__*/_react["default"].createElement("div", null, showAddToCart ? /*#__PURE__*/_react["default"].createElement(_fullscreenCartButton["default"], {
          cartItemsCount: this.getCartItemsCount(),
          mobileShopFrameOpen: !!(isMobile && showMobileShopFrame),
          onAddToCartRequest: addToCartRequest,
          styleParams: this.props.styles
        }) : null, showCheckoutLink ? /*#__PURE__*/_react["default"].createElement(_fullscreenCheckoutLink["default"], {
          cartItemsCount: this.getCartItemsCount(),
          onClick: this.goToCheckout
        }) : null);
      };
      _proto.closeMobileShopFrameIfOpen = function closeMobileShopFrameIfOpen() {
        this.isMobile && this.state.showMobileShopFrame && this.toggleMobileShopFrame();
      };
      _proto.toggleMobileShopFrame = function toggleMobileShopFrame() {
        if (this.isMobile) {
          this.setState({
            showMobileShopFrame: !this.state.showMobileShopFrame
          });
        }
      };
      _proto.fullScreenMobileShopElement = function fullScreenMobileShopElement(props) {
        var _this5 = this;
        var item = props.item || props.itm;
        var actions = _objectSpread(_objectSpread({}, props.actions), {}, {
          toggleMobileShopFrame: this.toggleMobileShopFrame,
          onLinkNavigation: this.props.onLinkNavigation
        });
        return item ? /*#__PURE__*/_react["default"].createElement(_fullscreenStoreBottomMobileBar["default"], {
          current: props.current,
          item: item,
          styleParams: props.styleParams,
          actions: actions,
          showShopFrame: true,
          showMobileShopFrame: this.state.showMobileShopFrame,
          showShareScreen: props.showShareScreen,
          galleryId: galleryInfo.galleryId,
          onClick: this.goToCheckout,
          providerView: this.state.providerView,
          onAddToCartRequest: function onAddToCartRequest() {
            return _this5.shopElement && _this5.shopElement.addToCartRequest();
          },
          onProviderAction: function onProviderAction(type, data) {
            return _this5.shopElement && _this5.shopElement.postShopRequest(type, data);
          },
          cartItemsCount: this.getCartItemsCount(),
          customShopWrapper: customShopWrapper,
          freeArtStore: this.isFreeArtStore
        }) : false;
      };
      _proto.getSideBarElement = function getSideBarElement(pgProps) {
        var ShopElement = !this.isFreeArtStore && this.fullScreenShopElement(pgProps);
        if (typeof customShopWrapper === 'function') {
          return customShopWrapper({
            ShopElement: ShopElement,
            pgProps: pgProps
          });
        } else {
          return ShopElement;
        }
      };
      _proto.getNavBarElement = function getNavBarElement() {
        var CartIcon = !this.isFreeArtStore && this.fullscreenCartIcon();
        if (typeof customIconWrapper === 'function') {
          return customIconWrapper({
            CartIcon: CartIcon
          });
        } else {
          return CartIcon;
        }
      };
      _proto.getFullscreenPage = function getFullscreenPage() {
        var _this6 = this;
        var customMobileSidebarRenderer = this.isMobile ? function (props) {
          return _this6.fullScreenMobileShopElement(props);
        } : false;
        var additionalSidebarElement = function additionalSidebarElement(pgProps) {
          return _this6.getSideBarElement(pgProps);
        };
        return /*#__PURE__*/_react["default"].createElement(ComposedComponent, _extends({}, this.props, {
          viewMode: viewMode,
          additionalSidebarElement: additionalSidebarElement,
          isAdditionalMobileSidebarOpened: this.state.showMobileShopFrame,
          additionalNavbarElement: function additionalNavbarElement() {
            return _this6.getNavBarElement();
          },
          customMobileSidebarRenderer: customMobileSidebarRenderer
        }));
      };
      _proto.goToCheckout = function goToCheckout() {
        this.closeMobileShopFrameIfOpen();
        isOOI ? this.pageManager.goToCheckout() : storeApi.onCheckout();
      };
      _proto.getPagesData = function getPagesData() {
        var _this$props$this$prop = _objectSpread(_objectSpread({}, this.props), this.props.host),
          cartItemsData = _this$props$this$prop.cartItemsData,
          additionalProviderParams = _this$props$this$prop.additionalProviderParams,
          checkoutParams = _this$props$this$prop.checkoutParams,
          changeStoreFrameState = _this$props$this$prop.changeStoreFrameState,
          consentPolicy = _this$props$this$prop.consentPolicy,
          appInstance = _this$props$this$prop.appInstance;
        return _objectSpread(_objectSpread({}, cartItemsData), {}, {
          additionalProviderParams: additionalProviderParams,
          wixSdk: wixSdk,
          changeStoreFrameState: changeStoreFrameState,
          checkoutParams: checkoutParams,
          storeApi: storeApi,
          consentPolicy: consentPolicy,
          appInstance: appInstance
        });
      };
      _proto.render = function render() {
        var _this$pageManager;
        if (!isOOI) {
          return this.getFullscreenPage();
        }
        var _this$props2 = this.props,
          fullscreenIdx = _this$props2.fullscreenIdx,
          pagesState = _this$props2.pagesState;
        var fullscreenPage = fullscreenIdx >= 0 ? this.getFullscreenPage() : null;
        var artStorePages = (_this$pageManager = this.pageManager) == null ? void 0 : _this$pageManager.getPages(this.getPagesData(), pagesState, 'gallery');
        return /*#__PURE__*/_react["default"].createElement("span", null, fullscreenPage, artStorePages);
      };
      return ArtStoreHOC;
    }(_react.Component);
    return ArtStoreHOC;
  };
};
var _default = exports["default"] = withArtStore;